(function() {
    // Run the function when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        // Run again after a slight delay to ensure all elements are loaded
        setTimeout(function() {
            reorderCollectionElements();
        }, 500);
    });

    // Also run on window load to handle any delayed rendering
    window.addEventListener('load', function() {
        reorderCollectionElements();
    });

    function reorderCollectionElements() {
        // Previous task: Move product grid below breadcrumb
        moveProductGridBelowBreadcrumb();
        
        // New task: Move h1 below div in collection header
        moveH1BelowDiv();
    }
    
    function moveProductGridBelowBreadcrumb() {
        // Find the collection product grid first div
        const productGridFirstDiv = document.querySelector('#CollectionProductGrid > div:first-child');
        
        // Find the breadcrumb component nav
        const breadcrumbNav = document.querySelector('[id^="HeaderCollectionSection"] breadcrumb-component nav');
        
        // Only proceed if both elements exist
        if (productGridFirstDiv && breadcrumbNav) {
            // Get the parent of the breadcrumb nav
            const breadcrumbParent = breadcrumbNav.closest('breadcrumb-component');
            
            // Insert the product grid div after the breadcrumb nav
            breadcrumbParent.after(productGridFirstDiv);
            
            console.log('Product grid moved below breadcrumb successfully');
        }
    }
    
    function moveH1BelowDiv() {
        // Get the collection header section
        const headerSection = document.querySelector('[id^="HeaderCollectionSection"]');
        
        if (headerSection) {
            // Find the h1 element
            const h1Element = headerSection.querySelector('div > div:first-child > div > div > h1');
            
            // Find the div element that should be above the h1
            const divElement = headerSection.querySelector('div > div:first-child > div > div > div');
            
            // Only proceed if both elements exist
            if (h1Element && divElement) {
                // Move the h1 to appear below the div
                divElement.after(h1Element);
                console.log('H1 element moved below div successfully');
            } else {
                console.log('Could not find required h1 or div elements:', 
                    h1Element ? 'H1 found' : 'H1 not found', 
                    divElement ? 'Div found' : 'Div not found');
            }
        }
    }
})();
